/**
 * Utility functions for working with datasets
 */

/**
 * Generates a user-friendly display name from a dataset path and ID
 * 
 * @param path - The path of the dataset (e.g., file path or URL)
 * @param id - The unique identifier of the dataset
 * @returns A user-friendly display name
 */
export function getDatasetDisplayName(path: string, id: string): string {
  // If path is empty or undefined, use a fallback based on ID
  if (!path) {
    return `dataset_${id.split('-')[0]}`;
  }

  // Extract filename from path
  const filename = path.split('/').pop() || path;
  
  // Remove file extension if present
  const nameWithoutExtension = filename.includes('.')
    ? filename.substring(0, filename.lastIndexOf('.'))
    : filename;
  
  // Replace special characters with spaces and clean up
  return nameWithoutExtension
    .replace(/[-() \[\]_\.]/g, ' ') // Replace special characters and dots with spaces
    .replace(/[^a-zA-Z0-9 ]/g, '') // Remove any remaining non-alphanumeric characters except spaces
    .replace(/ +/g, ' ') // Replace multiple consecutive spaces with a single space
    .trim(); // Remove leading/trailing spaces
} 